import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import InputCheckbox from '../../../components/input-checkbox/InputCheckbox'
import InputDropdownCheckbox from '../../../components/input-dropdown-checkbox/InputDropdownCheckbox'
import Loader from '../../../components/loader/Loader'
import { SortedTable, SortLink } from 'vue-sorted-table'
import { AccountService, Account } from '../../../services/account.service'
import { ScreenLoader } from '../../../utils/loading.util'
import Card from '../../../components/card/Card'
import { Customer, CustomerDropdown, CustomerService } from "@/services/customer.service";
import InputDropdown from "@/components/input-dropdown/InputDropdown"
import a from "vuex-persistedstate";
export default {
    name: 'Accounts',
    components: {
        Card,
        NavigationBar,
        TabBar,
        InputButton,
        InputText,
        InputCheckbox,
        InputDropdownCheckbox,
        InputDropdown,
        SortedTable,
        SortLink,
        Loader
    },

    data() {
        return {
            searchValue: '',
            accounts: [],
            customers: [],
            selectedCustomers: [],
            customerValue: '',
            sortedAccounts: [],
            screenLoader: new ScreenLoader(),
            showInactiveUsers: true,
            showPopup: false,
            selectedUsers: [],
            multiSelect: false,
            filters: [{id: 0, value: "Last active (asc)"}, {id: 1, value: "Last active (dsc)"}, {id: 2, value: "Role (dsc)"}, {id: 3, value: "Role (asc)"}],
            selectedFilter: ''
        }
    },

    mounted() {
        this.getCustomers()
        this.getAccounts()
    },

    methods: {
        selectRow(rowId) {
            if (this.multiSelect) {
                if (this.selectedUsers.includes(rowId)) {
                    this.selectedUsers = this.selectedUsers.filter(u => u !== rowId)
                } else {
                    const active = this.accounts.find(a => a.id === rowId).active
                    if (active) this.selectedUsers.push(rowId)
                }
            } else {
                router.push(`/settings/accounts/${rowId}`)
            }
        },

        search() {
            this.sortedAccounts = this.accounts.filter(account => {
                const foundName = this.propertyContainsValue(account.getName())
                const foundRole = this.propertyContainsValue(account.role)
                const foundCustomer = account.customers.map(customer => this.propertyContainsValue(customer.name)).includes(true)
                const foundLocation = this.propertyContainsValue(account.getLocations())
                const foundEmail = this.propertyContainsValue(account.emailAddress)
                return foundName || foundRole || foundCustomer || foundLocation || foundEmail
            })
        },

        propertyContainsValue(value) {
            return value ? value.toLowerCase().includes(this.searchValue.toLowerCase()) : false
        },

        clearSearch() {
            this.searchValue = ''
            this.sortedAccounts = this.accounts
        },

        getAccounts: async function() {
            this.screenLoader.start()

            try {
                const accounts = await AccountService.getAccounts()

                this.handleAccountsResponse(accounts)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        getCustomers: async function() {
            try {
                const customers = await CustomerService.getCustomers()
                this.customers = customers.map(c => new CustomerDropdown(c))
                this.updateCustomers()
            } catch (error) {
                console.warn(error)
            }
        },

        toggleActive() {
            this.showInactiveUsers = !this.showInactiveUsers
            let acc
            if (!this.showInactiveUsers) {
                 acc = this.accounts.filter(c => c.active == true)
            } else {
                 acc = this.accounts
            }
            this.sortedAccounts = acc
        },

        getDropdownValues(items){
            let values = []
            for (let i=0; i < items.length; i++) {
                if (items[i].checked) {
                    values.push(items[i])
                }
            }
            return values
        },

        updateCustomers() {
            const values = this.getDropdownValues(this.customers)
            this.selectedCustomers = values
            this.customerValue = values.map(i => i.value).join(', ')
            if (this.selectedCustomers.length != this.customers.length) {
                let acc = this.accounts.filter(a => {
                    let customers = a.customers
                    for (let c of customers) {
                        if (this.selectedCustomers.map(cus => cus.id).includes(c.id)){
                            return a
                        }
                    }
                })
                this.sortedAccounts = acc
            } else {
                this.sortedAccounts = this.accounts
            }
        },

        updateFilter(id){
            this.selectedFilter = this.filters.find(f => f.id === id).value
            const roles = ["Super user", "Warehouse manager", "Warehouse planner","Booking agent", undefined]
            let newAccounts = []
            switch (id) {
                case 0:
                    this.sortedAccounts = this.sortedAccounts.sort(function (a, b) {
                        return new Date(a.lastSeen) - new Date(b.lastSeen);
                    })
                    break;
                case 1:
                    this.sortedAccounts = this.sortedAccounts.sort(function (a, b) {
                        return new Date(b.lastSeen) - new Date(a.lastSeen);
                    })
                    break;
                case 2:
                    roles.reverse().forEach((role) => {
                        newAccounts.push(...this.sortedAccounts.filter(a => a.role == role))
                    })
                    this.sortedAccounts = newAccounts
                    break;
                case 3:
                    roles.forEach((role) => {
                        newAccounts.push(...this.sortedAccounts.filter(a => a.role == role))
                    })
                    this.sortedAccounts = newAccounts
                    break;

            }
        },

        handleAccountsResponse(accounts) {
            this.selectedCustomers.map(c => c.id)
            this.accounts = accounts ? accounts.map(o => new Account(o)) : []
            this.sortedAccounts = this.accounts
            this.screenLoader.stop()
        },

        async showAccountDetails() {
            await AccountService.exportDetails(this.accounts)
        },

        toggleDeactivation () {
            if (this.multiSelect) {
                this.selectedUsers = []
                this.multiSelect = false
            } else {
                this.multiSelect = true
            }
        },

        async deactivateUsers () {
            const promises = []
            for (let id of this.selectedUsers) {
                let user = this.accounts.find(account => account.id === id)
                user.active = false
                promises.push(AccountService.updateAccount(user))
            }
            await Promise.all(promises).then(() => {
                this.multiSelect = false
                this.selectedUsers = []
                this.getAccounts()

            })
        }


    }
}
